import { z } from 'zod';
/** The three first-class principals (BP-01 §2.4). Supplier-portal users come in a later slice. */
export const ROLES = ['user', 'org_admin', 'super_admin'];
export const roleSchema = z.enum(ROLES);
/** Magic-link purposes (BP-01 §3). */
export const MAGIC_LINK_PURPOSES = ['login', 'invite', 'supplier'];
export const magicLinkPurposeSchema = z.enum(MAGIC_LINK_PURPOSES);
/** Uniform error envelope: every error response is `{ error: { code, message } }` (BP-01 §4). */
export const errorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Optional field-level validation details. */
        details: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    }),
});
/** Stable machine-readable error codes used across the API. */
export const ERROR_CODES = {
    VALIDATION: 'validation_error',
    UNAUTHENTICATED: 'unauthenticated',
    FORBIDDEN: 'forbidden',
    NOT_FOUND: 'not_found',
    CONFLICT: 'conflict',
    RATE_LIMITED: 'rate_limited',
    TOTP_REQUIRED: 'totp_required',
    EXPIRED: 'expired',
    INTERNAL: 'internal_error',
};
export const emailSchema = z.string().trim().toLowerCase().email().max(320);
export const uuidSchema = z.string().uuid();
//# sourceMappingURL=common.js.map